import type { ReactNode } from "react";
import { CertificationModal } from "@modules/certificaciones/shared/ui";

type Props = {
  open: boolean;
  title: string;
  description?: string;
  size?: "default" | "wide";
  children: ReactNode;
  footer: ReactNode;
  onClose: () => void;
  onSubmit?: () => void;
};

export function Iso2700127701Modal({
  open,
  title,
  description,
  size = "default",
  children,
  footer,
  onClose,
  onSubmit,
}: Props) {
  return (
    <CertificationModal
      open={open}
      title={title}
      eyebrow="ISO 27001-27701"
      description={description}
      size={size}
      footer={footer}
      onClose={onClose}
      onSubmit={onSubmit}
    >
      {children}
    </CertificationModal>
  );
}
